import { QueryCache } from 'react-query';

export const sharedQueryCache = new QueryCache();
